import { render, staticRenderFns } from "./DuplicateDialog.vue?vue&type=template&id=65cb0cbb&scoped=true&"
import script from "./DuplicateDialog.vue?vue&type=script&lang=js&"
export * from "./DuplicateDialog.vue?vue&type=script&lang=js&"
import style0 from "./DuplicateDialog.vue?vue&type=style&index=0&id=65cb0cbb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65cb0cbb",
  null
  
)

export default component.exports